import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const BarbecueIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "BarbecueIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M11.6918 6.05807C12.0829 6.35143 12.0867 6.48109 11.6918 6.77726C11.4648 6.94747 11.4188 7.26949 11.589 7.49645C11.7584 7.72227 12.0802 7.77022 12.3082 7.59919C13.2424 6.89856 13.276 5.96198 12.3082 5.23615C11.9171 4.94279 11.9133 4.81313 12.3082 4.51696C12.5352 4.34672 12.5812 4.02473 12.411 3.79777C12.2408 3.57082 11.9188 3.52479 11.6918 3.69503C10.7575 4.39572 10.7241 5.33235 11.6918 6.05807Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M14.2602 6.05807C14.6505 6.35085 14.6558 6.4805 14.2602 6.77726C14.0332 6.94746 13.9872 7.26949 14.1574 7.49645C14.3268 7.72227 14.6486 7.77022 14.8766 7.59919C15.8128 6.89709 15.8425 5.96054 14.8766 5.23615C14.4855 4.94282 14.4818 4.81313 14.8766 4.51696C15.1036 4.34672 15.1496 4.02473 14.9794 3.79777C14.8091 3.57078 14.4871 3.52482 14.2602 3.69503C13.324 4.39716 13.2943 5.33371 14.2602 6.05807Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M9.12343 6.05807C9.51457 6.35143 9.51833 6.48109 9.12343 6.77726C8.89648 6.94747 8.85045 7.26949 9.02069 7.49645C9.19004 7.72227 9.51183 7.77022 9.73988 7.59919C10.6741 6.8985 10.7075 5.96187 9.73988 5.23615C9.34874 4.94279 9.34498 4.81313 9.73988 4.51696C9.96683 4.34672 10.0129 4.02473 9.84262 3.79777C9.67241 3.57082 9.35042 3.52479 9.12343 3.69503C8.18917 4.39572 8.15578 5.33235 9.12343 6.05807Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M3.74667 8.7984H5.32203V9.31211C5.32203 11.9596 6.87068 14.2523 9.10968 15.3317C9.01978 15.6014 7.59822 19.8661 7.40319 20.4511C7.29196 20.7848 7.54172 21.1275 7.89059 21.1275C8.10566 21.1275 8.30611 20.9913 8.37789 20.776L8.94574 19.0725H11.4865V20.6136C11.4865 20.8973 11.7165 21.1273 12.0002 21.1273C12.2839 21.1273 12.5139 20.8973 12.5139 20.6136V19.0725H15.0546L15.6224 20.776C15.6942 20.9913 15.8946 21.1274 16.1098 21.1274C16.4587 21.1274 16.7084 20.7848 16.5972 20.4511C16.4003 19.8604 14.9801 15.6001 14.8907 15.3317C17.1297 14.2523 18.6783 11.9596 18.6783 9.3121V8.79839H20.2537C20.5374 8.79839 20.7674 8.56839 20.7674 8.28468C20.7674 8.00097 20.5374 7.77097 20.2537 7.77097H18.1646C17.8809 7.77097 17.6509 8.00097 17.6509 8.28468V8.79839H6.3494V8.28468C6.3494 8.00098 6.1194 7.77097 5.83569 7.77097H3.74662C3.46292 7.77097 3.23291 8.00097 3.23291 8.28468C3.23291 8.56839 3.46293 8.7984 3.74667 8.7984ZM9.28821 18.0451L10.0683 15.705C10.5226 15.8425 10.9972 15.9333 11.4865 15.9707V18.045L9.28821 18.0451ZM14.7122 18.0451H12.5139V15.9707C13.0032 15.9333 13.4777 15.8426 13.9321 15.7049L14.7122 18.0451ZM17.6278 9.82581C17.3675 12.7019 14.943 14.9629 12.0002 14.9629C9.05741 14.9629 6.63283 12.7019 6.37258 9.82581H17.6278Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default BarbecueIcon;
